import dayjs from 'dayjs'
import {
  isLatestSummaryResponse,
  isRankingSummaryResponse,
  LatestSummary,
  TopRecommendSummary,
  RankingSummary,
  Recommend,
} from '@/types/summary'
import { RankBadge } from '@/components/summary/RankBadge'
import { SummaryLink } from '@/components/summary/SummaryLink'
import { SummaryImage } from '@/components/summary/SummaryImage'
import { SummaryDetail } from '@/components/summary/SummaryDetail'
import { IconNew } from './IconNew'

interface Props {
  summary: LatestSummary | RankingSummary | TopRecommendSummary | Recommend
  showRankBadge?: boolean
}

export const Summary: React.FC<Props> = ({
  summary,
  showRankBadge = false,
}) => {
  const { id, title } = summary
  const weekago = dayjs().subtract(8, 'd')
  return (
    <div>
      {!showRankBadge &&
        isLatestSummaryResponse(summary) &&
        dayjs(summary.released).isAfter(weekago) && <IconNew />}
      {showRankBadge && isRankingSummaryResponse(summary) && (
        /** ランキングの場合はランクバッジを表示する */
        <RankBadge rank={summary.rank} />
      )}
      <SummaryImage id={`${id}`} title={title} size="150" />
      <SummaryDetail summary={summary} />
      <SummaryLink id={`${id}`} />
    </div>
  )
}
